var _path, _path2, _path3, _path4, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeakerWithWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 84,
    viewBox: "0 0 78 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.5792 11.6781C75.1255 12.5061 74.0541 12.9312 73.0457 12.6851L71.7097 12.3494C67.974 13.8004 67.1126 15.1525 67 19.5V80.3538C67 82.4461 65.4173 84 63.0603 84H15.5059C13.1363 84 11 82.4461 11 80.3538L10.6415 8.21071C10.6415 6.68907 10.1121 5.33419 9.15416 4.05869C8.64999 3.09648 9.44406 2 10.6415 2H60.4288C65.8108 2 70.9534 3.958 74.6591 7.40407C76.0078 8.48936 76.3859 10.2348 75.5792 11.6781Z",
    fill: "#D9ECF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.992 54L61.0197 53.9771C63.2153 53.9771 65 52.8182 65 51.3923V38.2222C46.1083 37.7952 36.1218 36 12 36L12 51.4076C12 52.841 13.7847 54 15.992 54Z",
    fill: "#33BEF2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 41.4V78.8492C12 80.5965 13.7831 82.0092 15.9885 82L60.9763 81.9721C63.17 81.9721 65 80.498 65 78.76V37.08C65 36.764 64.9765 36.316 65 36C46.4887 36.1394 37.8205 41.4 12 41.4Z",
    fill: "#66CEF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 9C15 8.44772 15.4477 8 16 8H25C25.5523 8 26 8.44772 26 9C26 9.55228 25.5523 10 25 10H17V22H25C25.5523 22 26 22.4477 26 23C26 23.5523 25.5523 24 25 24H17V36H25C25.5523 36 26 36.4477 26 37C26 37.5523 25.5523 38 25 38H17V50H25C25.5523 50 26 50.4477 26 51C26 51.5523 25.5523 52 25 52H17V64H25C25.5523 64 26 64.4477 26 65C26 65.5523 25.5523 66 25 66H17V78H25C25.5523 78 26 78.4477 26 79C26 79.5523 25.5523 80 25 80H16C15.4477 80 15 79.5523 15 79V65V51V37V23V9Z",
    fill: "#668BA6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 7,
    width: 13,
    height: 73,
    rx: 3,
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeakerWithWater);
export default __webpack_public_path__ + "static/media/beaker_with_water.267d37e6f8d61e2b6a8bad2fd7bb0a3f.svg";
export { ForwardRef as ReactComponent };